module.exports = __webpack_public_path__ + "img/OlPejetaLogo.b6baecd7.png";